













import { Component, Vue, Prop } from "vue-property-decorator";
import TableComponent from "@/components/table/TableComponent.vue";

interface Room {
  token: string;
  name: string;
  number: string;
  isUsed: boolean;
}

@Component({
  components: {
    TableComponent
  }
})
export default class RoomTable extends Vue {
  @Prop({ type: String, required: true }) title!: string[];
  @Prop({ type: Array, required: true }) rooms!: Room[];
}
